<template>
  <DxButton id="footer-button"
            :text="text"
            :icon="icon"
            :disabled="disabled"
            styling-mode="text"
  />
</template>

<script setup>
  import DxButton from "devextreme-vue/button";

  const props = defineProps(['text', 'icon', 'disabled'])
</script>

<style scoped lang="scss">
  #footer-button {
    margin: 5px;
  }
</style>
